import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthedComponent } from './pages/authed.component';
import { MenuComponent } from '../components/menu/menu.component';
import { MenuToolbarComponent } from '../components/menu-toolbar/menu-toolbar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { SharedModule } from '@app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { ScreeningService } from '@app/store/screening/screening.service';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [AuthedComponent, MenuComponent, MenuToolbarComponent],
  imports: [CommonModule, BrowserAnimationsModule, SharedModule, FlexLayoutModule, RouterModule],
  exports: [],
  providers: [ScreeningService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AuthedModule {}
